import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: string;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconCircle = ({ id, color, width = 44, style, ...restProps }: IProps) => {
  const icon = ({ iconColor, width }: IconTypes) => (
    <svg viewBox={`0 0 ${width} ${width}`} width={width} height={width} fill="none">
      <rect width={width} height={width} rx={width / 2} fill={iconColor} />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={width}
      viewBoxHeight={width}
      style={style}
      {...restProps}
    />
  );
};

export default IconCircle;
